module.exports = __webpack_public_path__ + "img/tools.cc7f5c95.svg";